import InnerHtml from "@/app/[slug]/components/innerHtml"
import { containerBreakpoints } from "@/components/breakpoints"
import { Button, Box, Text, Heading, Container, Tag } from "@chakra-ui/react"
import { FaCalendar } from "react-icons/fa"
import dayjs from "dayjs"

import Link from "next/link"
import BlogCategoriesList from "./BlogCategoriesList"

const ConteudoTextoBlog = (props: any) => {
    const { data, categories, children } = props

    const before = {
        position: 'absolute',
        top: 0,
        content: '""',
        width: '7px',
        height: '7px',
        display: 'block',
        backgroundColor: '#cc0007',
        borderRadius: '50%',
        marginBottom: '16px'
    }
    const beforeCenter = { ...before, ...{ left: '50%' } }
    const beforeLeft = { ...before, ...{ left: 0 } }
    const beforeRight = { ...before, ...{ right: 0 } }

    const getSubtitleDecoration = () => {
        if (data.Alinhamento === 'Direita') {
            return beforeRight
        }
        if (data.Alinhamento === 'Centro') {
            return beforeCenter
        }
        return beforeLeft
    }

    const getTextAlign = () => {
        if (data.Alinhamento === 'Direta') {
            return 'end'
        }
        if (data.Alinhamento === 'Centro') {
            return 'center'
        }
        return 'start'
    }
    //console.log('data ->', data)

    const beforeTime = {
        content: "'•'",
        display: 'inline-block',
        verticalAlign: 'middle',
        fontSize: '0.8em',
        marginTop: '-2px',
        color: 'rgb(217, 10, 44)'
    }

    function VoltarButton() {
        return (
          <Button onClick={() => window.history.back()}>
            Voltar
          </Button>
        )
    }

    const formatDate = (date:string) => dayjs(date).format('DD/MM/YYYY')

    return (
        <Box as="section" className="blog-page" mt={'-30px'} mb={'100px'}>
            <Container maxW={containerBreakpoints}>
                <Box w={'full'} gap={2} display={'flex'} justifyContent={'end'} px={4}>
                    <Button onClick={() => window.history.back()}>
                        Voltar  
                    </Button>
                </Box>
                <Box w={'full'} px={4}>
                    {data?.Subtitulo &&
                        <Text className="blog-subtitulo" as='h5' _before={getSubtitleDecoration()} pos='relative' pt={'16px'} textAlign={getTextAlign()} w={'100%'} fontSize={'14px'} lineHeight={1.2} textTransform={'uppercase'} letterSpacing={'1.4px'} fontWeight={'500'} margin={'0 0 7px'} fontFamily={"'Plus Jakarta Sans', sans-serif"}>
                            {data?.Subtitulo}
                        </Text>
                    }
                    {data?.Titulo &&
                        <Heading className="blog-titulo" as='h1' mb={10} fontSize={'50px'} letterSpacing={'-2px'} textAlign={getTextAlign()} fontWeight={800} fontFamily={"'Plus Jakarta Sans', sans-serif"}>
                            {data?.Titulo}
                        </Heading>
                    }
                </Box>
                <Box w={'full'} gap={2} display={'flex'} mb={10} justifyContent={'end'} px={4}>
                    {data?.BlogCategorias?.data.map((tag:any)=> { 
                        return <Tag key={tag?.id}>{tag?.attributes?.Nome}</Tag>
                    })}
                    {data?.Tags?.data.map((tag:any)=> { 
                        return <Tag key={tag?.id}>#{tag?.attributes?.Nome}</Tag>
                    })}
                    <Text _before={beforeTime}> {data?.TempoLeitura}</Text>
                    <Text _before={beforeTime}> <FaCalendar className="icon-calendar" />&nbsp;Publicado em: {formatDate(data?.dataPublicacaoPost)}</Text>
                    
                </Box>

                <Box w={'100%'} display={'flex'}>
                    <Box w={{ sm: '100%', md: '75%' }} display={'flex'} p={4} flexDirection={'column'}>
                        <InnerHtml className="blog-descricao" fontSize={'17px'} lineHeight={'29px'} pb={'10px'} fontWeight={500} html={data?.Conteudo} />
                        <Box w={'full'}>
                            {children}
                        </Box>
                    </Box>
                    <Box w={'25%'} p={4} display={{ base: 'none', sm: 'none', md: 'block' }}>
                        <BlogCategoriesList categories={categories} />
                    </Box>
                </Box>
            </Container>
        </Box>
    )
}

export default ConteudoTextoBlog